import React from 'react';
import { Heading, Modal, ModalBody, ModalContent, ModalDialog, ModalFooter, ModalHeader,Link } from "arag-ui-lib";
import CustomTable from "../General/customTable/CustomTable";
import accounting from 'accounting';
import { CANADA_COUNTRY, COUNTRY, CURRENCY } from "../../helpers/variables";
import { TAX } from "../../helpers/constants";

const isCanada = COUNTRY == CANADA_COUNTRY;
const payPremiumText =  "Please ensure you pay the premium " + (isCanada ? '' : "and disbursement")  + "  due"
  

const CostsSummary = (props) => {
    const {costsSummary, costsSummaryModal, toggleCostsSummaryModal, selectedApp} = props;
    const taxText =  "All Insurance Premiums stated are inclusive of Insurance Premium Tax at " + costsSummary.taxPercentage +"%"

    const damagesReceivedColumns = [
        {propertyName: 'damages', header: 'Damages Received'},
        {propertyName: 'netPremium', header: 'Premium payable (excl. ' + TAX + ')'},
        {propertyName: 'premiumTax', header: TAX},
        {propertyName: 'premium', header: 'Total \n\r Premium payable (incl. ' + TAX + ')'}
    ];

    if(selectedApp && selectedApp.caseTypeName == 'Clinical Negligence'){
        damagesReceivedColumns.push(            
                {propertyName: 'recoverable', header: 'Insurance Premium recoverable from your opponent'},
                {propertyName: 'payable', header: 'Insurance Premium payable from your damages'}
            );
    }

    const stagedPremiumSelected = [
        {propertyName: 'stage', header: 'Stage',},       
        {propertyName: 'netPremium', header: 'Premium payable (excl. ' + TAX + ')'},
        {propertyName: 'premiumTax', header: TAX},
        {propertyName: 'premium', header: 'Total \n\r Premium payable (incl. ' + TAX + ')'},
    ];
    
    const adsNotSettled = [
        {propertyName: 'type', header: 'Disbursement Type',},
        {propertyName: 'amount', header: 'Amount', formatter: (row) => accounting.formatMoney(row.amount, CURRENCY, 2)},
        {propertyName: 'status', header: 'Status',},
        {propertyName: 'settledAmount', header: 'Settled Amount', formatter: (row) => accounting.formatMoney((row.totalAmount - row.unsettledAmount), CURRENCY, 2)},
        {propertyName: 'createdOn', header: 'Date Created',},
        {propertyName: 'paidOn', header: 'Date Paid',},
        {propertyName: 'reference',	header: 'Payment Reference',},
    ];
    
return (
    <div>
    {costsSummary &&
        <Modal fadeIn={costsSummaryModal} darkenedBackground>
            <ModalDialog size={'lg'}>
                <ModalContent>
                    <ModalHeader title="Costs summary" onClose={toggleCostsSummaryModal} />
                    <ModalBody contained>
                        <Heading variant="h3" title={payPremiumText} />
                        {!costsSummary?.stageName && 
                        <CustomTable
                            columns={!costsSummary?.damagesReceived ? damagesReceivedColumns.filter(c => c.propertyName !== "damages") : damagesReceivedColumns}
                            data={[
                                {
                                    damages: costsSummary?.damagesReceived,
                                    premium: `${accounting.formatMoney(costsSummary?.insurancePremium, CURRENCY, 2)} `,
                                    netPremium: `${accounting.formatMoney(costsSummary?.netPremium, CURRENCY, 2)} `,
                                    premiumTax: `${accounting.formatMoney(costsSummary?.netPremiumTax , CURRENCY, 2)} `,
                                    recoverable:`${accounting.formatMoney(costsSummary?.recoverable, CURRENCY, 2)} `,
                                    payable:`${accounting.formatMoney(costsSummary?.payable, CURRENCY, 2)} `,
                                }
                            ]}
                        />}
                        {costsSummary?.stageName && 
                        <CustomTable
                            columns={stagedPremiumSelected}
                            data={[
                                {
                                    damages: `${CURRENCY} ` + costsSummary?.damagesReceived,                           
                                    stage: costsSummary?.stageName,
                                    premium: `${accounting.formatMoney(costsSummary?.insurancePremium, CURRENCY, 2)} `,
                                    netPremium: `${accounting.formatMoney(costsSummary?.netPremium, CURRENCY, 2)} `,
                                    premiumTax: `${accounting.formatMoney(costsSummary?.netPremiumTax , CURRENCY, 2)} `,
                                    payable:`${accounting.formatMoney(costsSummary?.payable, CURRENCY, 2)} `,
                                }
                            ]}
                        />}
                        {costsSummary?.paidPartSettledADs?.length > 0 ?
                            <CustomTable
                                columns={adsNotSettled}
                                data={
                                    costsSummary?.paidPartSettledADs.map(ad => {
                                        return (
                                            {
                                                type: ad.description,
                                                amount: ad.totalAmount,
                                                status: ad.status,
                                                totalAmount:ad.totalAmount,
                                                unsettledAmount: ad.unsettledAmount,
                                                createdOn: ad.creationDate ? (new Date(ad.creationDate?.split('T')[0])?.toLocaleDateString('en-GB')) : '',
                                                paidOn: ad.paymentDate ? (new Date(ad.paymentDate?.split('T')[0])?.toLocaleDateString('en-GB')) : '',
                                                reference: ad.paymentInstructionId,
                                            })
                                    })}
                            /> : (isCanada ? null : <Heading variant="h3" title="No disbursement was paid out" />)}
                            {isCanada ? null : <Heading variant="h3" title={taxText} />}
                    </ModalBody>
                    <ModalFooter>
                        <Link
                            type="button"
                            variant="tertiary"
                            arrowDirection="left"
                            label="Close"
                            onClick={toggleCostsSummaryModal}
                        />
                    </ModalFooter>
                </ModalContent>
            </ModalDialog>
        </Modal>}
        </div>

)

}
export default CostsSummary;